import { type SceneControl, Vector2, lib, use } from '@anov/3d-core'

const { UnrealBloomPass } = lib
const { useScene } = use

type BloomPassOptions = {
  threshold?: number
  strength?: number
  radius?: number
}

/**
 * create bloom pass
 */
const addBloomPass = (bloomPass: BloomPassOptions = {}, sceneControl: SceneControl) => {
  const { scene, camera } = useScene(sceneControl)
  const composer = sceneControl.context.storeManagement.get('composer') as lib.EffectComposer | undefined

  if (!scene || !camera)
    throw new Error('scene or camera is not defined,')

  if (!composer)
    throw new Error('composer is not defined, please initPostEffects first')

  const bloom = new UnrealBloomPass(new Vector2(window.innerWidth, window.innerHeight), 1.5, 0.4, 0.85)

  bloom.threshold = bloomPass?.threshold ?? 0.85
  bloom.strength = bloomPass?.strength ?? 1.5
  bloom.radius = bloomPass?.radius ?? 0.4

  composer.addPass(bloom)

  return () => {
    composer.removePass(bloom)
  }
}

export default addBloomPass